import React, { useEffect, useRef, useState } from 'react'
import { Helmet } from 'react-helmet'
import { useNavigate, Link, useParams } from 'react-router-dom'
import ReactPaginate from 'react-paginate';
import axios from 'axios'
import moment from 'moment'
import {useList} from 'react-use';
import { AnimatedCircleStatus, Button, Main , PageHeader , Card, Skeleton, Alert } from '../../Components'
import { useConfirmationModal } from '../../Hooks/useNotifications';
import toast from 'react-hot-toast';
import { automateMonitoringService, incidentImpact, incidentStatus } from '../../Constants/Constants';


import './incidents.css'
import { TbDatabaseImport } from 'react-icons/tb';
import Tooltip from 'rc-tooltip';
import { randomIntInterval } from '../../Helpers';
import { useSelector } from 'react-redux';
import useWindowDimensions from '../../Hooks/useWindowDimensions';
import {TbEdit } from 'react-icons/tb'
import {FiTrash2} from 'react-icons/fi'

export function Incidents() {

	const effectCalled = useRef(false)
	const { page_id } = useParams();
	const navigate = useNavigate()
	const { user , org} = useSelector((state) => state.auth)

	const { getConfirmation } = useConfirmationModal();
    const { width } = useWindowDimensions();
	 
	 
	 
	// const [activeTab, setActiveTab] = useState(1);
	

	if(!page_id){
		navigate('/pages')
	}

   

	const [isLoading, setIsLoading] = useState(true)
	const [incidents, setIncidents] = useList([])
	const [activePage, setActivePage] = useState(0);
	const [listPerPage, setListPerPage] = useState(10);
	const [totalRecords, setTotalRecords] = useState(0);
	const [openedRemovingIncident, setOpenedRemovingIncident] = useState(false);
	// const [updatedComponent, seUpdatedComponent] = useState(0)


	useEffect( () => {
		
		// if(effectCalled.current){ return ;} 
		async function fetchData() {

              // ! CHECK THE ACCESS 
            if(org?.statuspages?.findIndex(x => x.id === page_id) < 0 ) {
                navigate(`/pages`)
                return
            }

			//console.log('activePage / listPerPage : ' , activePage , listPerPage , activePage / listPerPage);
			getIncidents({
				page : activePage , // / listPerPage,
				per_page : listPerPage
			})
		}
		fetchData();

		// effectCalled.current = true ;
		
	}, [activePage])

	/**
	 * GET INCIDENTS LIST 
	 */
	const getIncidents = async ({ page , per_page}) => {

		return new Promise(async(resolve, reject) => { 

			setIsLoading(true)
			
			
			
			
			if (user && user.token && org && org?.id ) {
				
				let params = {
					page : page ,
					per_page : per_page,
					 
				}

				const token = user?.token;


				await axios.get(`${process.env.REACT_APP_API_URL}/statuspages/${page_id}/incidents` , {
					params :params,
					headers: {
						'Authorization': `Bearer ${token}`
					},
				})
				.then( res => res.data )
				.then( data => {

					// Total records 
					setTotalRecords(data.total);

					setIncidents.set(data.data)

					setIsLoading(false)
		
					resolve(data.data) 
		
				})
				.catch(error => {
					if(error?.response?.data?.error ==='USER_NOT_LOGIN'){
						navigate('/logout')
					}
					setIsLoading(false)
					if (error.response) {
						if(typeof error.response.data.statusCode!=='undefined' && error.response.data.statusCode===404){
						
							setIncidents.set([])
						}
						reject((typeof error.response.data.error.message !=='undefined') ? error.response.data.error.message : error.response.data.message);
					} else {
						// Something happened in setting up the request that triggered an Error
						if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
								reject(`Something went wrong. Thank you try later.`)
						}
					}
				})
			}else{
				setIsLoading(false)
			}

		})
	}

	/**
	 * 
	 * @param {*} params 
	 */
	const openDeleteIncidentModal = (params) => {

		 
		getConfirmation({
			size : 'small',
			type: 'danger',
			title: "Deleting incidents",
			message: "Are you sure you want to delete your incident? ",
			labels: { confirm: 'Delete incident', cancel: "No don't delete it" },
			onConfirm : () => {
				deleteIncident(params?.incident_id)
			},
			onCancel : () => {
				 

			}
		});
		 
	}

	/**
	 * ! DELETE AN INCIDENT
	 */	
	const deleteIncident = (INCIDENT_ID) => {

		return new Promise( async (resolve, reject) => { 
			
			// setIsLoading(true)
			 

			
			
			
			
			
			if (user && user.token && org && org?.id ) {
				 

				const token = user?.token;


				await axios.delete(`${process.env.REACT_APP_API_URL}/statuspages/${page_id}/incidents/${INCIDENT_ID}`, {
					params : {},
					headers : {
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${token}`,//'JWT token...'
					}
				} )
				.then( res => res.data )
				.then( data => {


					let _incidents = [...incidents];
					// _incidents = _incidents.filter((p) => p.id !== INCIDENT_ID);
					const index = _incidents.findIndex((p) => p.id === INCIDENT_ID);

					setIncidents.removeAt(index) //(_incidents);

					// Update the Total records 
					let _totalRecords = totalRecords
					setTotalRecords(--_totalRecords);
					// setIsLoading(false)
 
					 
					toast.success('Your incident has been successfully deleted')



					// components list 
					resolve(data.data)  
		
				})
				.catch(error => {
					if(error?.response?.data?.error ==='USER_NOT_LOGIN'){
						navigate('/logout')
					}
					// setIsLoading(false)
					if (error.response) {
						if(typeof error.response.data.statusCode!=='undefined' && error.response.data.statusCode===404){
						
							 
						}
						reject((typeof error.response.data.error.message !=='undefined') ? error.response.data.error.message : error.response.data.message);
					} else {
						// Something happened in setting up the request that triggered an Error
						if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
							reject(`Something went wrong. thank you try later.`)
						}
					}

					toast.success('Something went wrong, please try again later.')
					 
				})
			}else{
				// setIsLoading(false)
				toast.success('Something went wrong, please try again later.')
			}


		})
	}

	let headerActionButtons = []
	headerActionButtons.push({
		name : "Add an incident",
		link : `/pages/${page_id}/incidents/new`
	} )


	const SkeletonLoader_itemList = () => {
		return(
			[...Array(listPerPage)].map( (item, index) => {
				return( 
					<Card key={index}   className='incident-item' >
						<div className='incident-wrapper'>
							<div className='incident-status'>
								<Skeleton width={20} height={20} circle />
							</div>
							<div className='incident-main_content'>
								<div className='incident-title' ><Skeleton width={`${randomIntInterval(40 , 60)}%`} height={16} radius="sm" /></div>
								<div className='incident-desc'>
									<div className='tag-wrapper'>
										<Skeleton width={60} height={18} radius="sm" />
									</div>
									<div className='date'><Skeleton width={`40%`} height={15} radius="sm" /></div>	
								</div>
							</div>
							<div className='incident-actions'>
								<Skeleton className='mr-10' width={30} height={20} radius="sm" />
								<Skeleton className='mr-10' width={30} height={20} radius="sm" />
							</div>
							
						</div>
					</Card>
				)   
			})
		)  
	}

	/**
	 * 
	 */
	const getActivePage = () => {
		
		// Find the current status page from organization in Redux 
		const index = org?.statuspages?.findIndex( x => x.id === page_id)
		if(index >=0 ){
			return org?.statuspages[index]
		}   
		
		return false
	} 

	 
    let breadcrumbsItems = []
    if(width > 450 ) breadcrumbsItems.push({ name: 'Home', link: '/' })
    breadcrumbsItems.push({ name: 'Status Pages', link: '/pages' })
    breadcrumbsItems.push({ name: getActivePage()?.name ?? 'Untitle Page' , link: `/pages/${page_id}` })
    if(width > 450 ) breadcrumbsItems.push({ name: 'Incidents', link: '' })

	
  	return (
		<>
		<Helmet>
            <title>{`Incidents - ${process.env.REACT_APP_APP_NAME}`}</title>
		</Helmet>
		<Main 
			breadcrumbsItems={breadcrumbsItems}
			activePage={incidents?.length > 0 ? incidents[0]?.statuspage : null }
			 >
				<PageHeader
					title="Incidents"
					// description="Give your account a recognisable name, so your team mates can easily switch between accounts."
					actionBtns={headerActionButtons}
					/>
				{
					isLoading === true 
					? <SkeletonLoader_itemList />
					: (
						incidents.length <= 0 
						? <Alert color="" >No result found</Alert>                        
						: incidents.map( (item , index ) => {

								const _lastUpdate = (item?.updates !==null && item?.updates?.length > 0) 
									? incidentStatus.find( x => x.id === item?.updates[0]?.status)
									: null ;
		
									
								return (
									<Card key={index} shadow="sm" className='incident-item' >
										<div className='incident-wrapper'>
											<div className='incident-status'>
												<AnimatedCircleStatus 
													status={ incidentImpact.find(x =>x.id === item?.impact)?.color ?? 'none' }
												/>
											</div>
											<div className='incident-main_content'>
												<Link 
													className='incident-title'
													to={`/pages/${page_id}/incidents/${item?.id}/edit`}
													
													>{item?.name}
													</Link>
												<div className='incident-desc'>
													{ _lastUpdate &&  
														<div className='tag-wrapper'>
															<div className={`tag ${_lastUpdate?.id}`} >{ _lastUpdate?.name}</div>
														</div>
													}
													<div className='date'>{`Last update on ${moment(_lastUpdate?.updated_at).format('dddd, MMMM Do YYYY, h:mm A')}`}</div>	
												</div>
											</div>
											<div className='incident-actions'>
												<Link 
													color="purple"
													className='btn btn-link btn-purple mr-10'
													to={`/pages/${page_id}/incidents/${item?.id}/edit`}
													>{
                                                        width <= 450
                                                        ? <TbEdit className='action-icon'/>
                                                        : 'Update'
                                                    }</Link>
												<Button 
													color="red"
													link={true}
													onClick={() => openDeleteIncidentModal({ incident_id : item?.id })} 
													>{
                                                        width <= 450
                                                        ? <FiTrash2 className='action-icon'/>
                                                        : 'Delete'
                                                    }</Button>
												{
													item?.updates !==null && item?.updates?.length && item?.updates[0]?.automation_source !==null && 
													<Tooltip
														placement="left" 
														trigger={['hover']} 
														overlay={<span>{`This incident was generated automatically from the ${automateMonitoringService?.find( x => x.value === item?.updates[0]?.automation_source)?.label} monitoring service`}</span>}
													>
														<div className="automation_source-tag"><TbDatabaseImport />{ automateMonitoringService?.find( x => x.value === item?.updates[0]?.automation_source)?.label }</div>
													</Tooltip>
												}
											</div>
											
										</div>
									</Card>
								)
							})
					)
						 
				}
				{
					isLoading === false && Math.ceil(totalRecords/ listPerPage) > 1 && 
					<ReactPaginate
						previousLabel={""}
						nextLabel={""}
						breakLabel={"..."}
						breakClassName={"break-me"}
						pageCount={Math.ceil(totalRecords/ listPerPage)} 
						marginPagesDisplayed={2}
						pageRangeDisplayed={5}
						onPageChange={ async (e) => {

							const number = e.selected;
							//console.log(number);

							setActivePage(number)
							// await getIncidents({
							// 	page : Math.ceil(number/ listPerPage),
							// 	per_page : listPerPage
							// })
						}}
						containerClassName={"pagination"}
						subContainerClassName={"pages pagination"}
						activeClassName={"active"}
						forcePage={activePage}
						/>
				}
		</Main>
		</>
	)
}
